import gradient2svg from "gradient2svg";
import { useEffect, useRef, useState } from "react";

import type { RecursivePartial } from "@intelligems/ig-types";

export function useSvgColor(color: string) {
  const ref = useRef(0);
  const [gradientId, setGradientId] = useState(0);

  useEffect(() => {
    ref.current++;
    setGradientId(ref.current);
  }, [color]);

  if (color.startsWith("#")) {
    return { color };
  }
  const gradient = gradient2svg(color);
  if (gradient === undefined) {
    return { color };
  }
  return {
    defs: gradient.replace(
      /<linearGradient|<radialGradient/,
      `$& id="color${gradientId}"`
    ),
    color: `url(#color${gradientId})`,
  };
}

export function cls(...classNames: (string | undefined)[]) {
  return classNames.filter((c) => Boolean(c)).join(" ");
}
